import React, { useState, useRef, useEffect } from "react";
const Dropdown = ({
  items,
  placeholder = "Select an option",
  defaultValue,
  setLeagueSelectedId,
}) => {
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(defaultValue || "");
  const wrapperRef = useRef(null);
  useEffect(() => {
    setSelectedId(defaultValue || "");
  }, [defaultValue]);
  const selectedItem = items?.find((item) => item.id === selectedId);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleDropdown = () => setOpen((prev) => !prev);

  const handleSelect = (id) => {
    setLeagueSelectedId(id);
    setSelectedId(id);
    setOpen(false);
  };

  return items?.length ? (
    <div className={"dropdown_wrapper"}>
      <div className={"dropdown_inner"} ref={wrapperRef}>
        <div className={"selected"} onClick={toggleDropdown}>
          <span className="selected_text">
            {selectedItem ? selectedItem.name : placeholder}{" "}
          </span>

          <span className={`${"ico_down_arrow arrow"} ${open ? "open" : ""}`} />
        </div>
        {open && (
          <div className={"options"}>
            {items.map(({ id, name }) => (
              <div
                key={id}
                className={`${"option"}`}
                onClick={() => handleSelect(id)}
              >
                {name}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  ) : null;
};

export default Dropdown;
